import { Injectable, inject } from '@angular/core';
import { Observable, Subject, take } from 'rxjs';
import { SYSTEM_CONST } from '../../constants/system-constants.model';
import { CommonService, TranslationService } from '@waseel-asp/tpa-waseel-lib-staging';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  private translation = inject(TranslationService);
  private commonService = inject(CommonService);

  formValue = new Subject<{ event: string, data: object }>;

  emitValue(data: { event: string, data: object }) {
    this.formValue.next(data);
  }

  confirmActionDialog(messageKey?: string, title?: string): Observable<boolean> {
    return this.commonService.confirmDialodMessage({
      title: title ?? SYSTEM_CONST.CONFIRM,
      message: this.translation.instant(messageKey ?? 'COMMON.DELETE_CONFIRMATION_MSG')
    }).afterClosed().pipe(take(1));
  }
}